export default function currencyPairCheck(props) {
const currencies = {
  GBP: "£",
  NGN: "₦",
  USD: "$",
  KES: "KES ",
  EUR: "€",
  USDT: "USDT ",
  USDC: "USDC ",
};

  return currencies[props] || "";
}
